export class RequestStoppingReasonListItem {
    requestStoppingReasonId: number;
    text: string;
    description: string;
    isActive: boolean;
    customerContragentId: number;
    requestStoppingReasonKindId: number;
    requestStoppingReasonKindName: string;
}